// extracted by mini-css-extract-plugin
export var doganimation = "SocialSharing-module--doganimation--9e5a5";
export var dogstatic = "SocialSharing-module--dogstatic--0c63b";
export var sharetoicons = "SocialSharing-module--sharetoicons--1f8f6";
export var sharetolabel = "SocialSharing-module--sharetolabel--af3e6";
export var sharetolabelcontainer = "SocialSharing-module--sharetolabelcontainer--54d5e";
export var sharetolabelhighlighted = "SocialSharing-module--sharetolabelhighlighted--d7ebe";
export var socialmediawrapper = "SocialSharing-module--socialmediawrapper--60eef";
export var socialmediawrapperprimary = "SocialSharing-module--socialmediawrapperprimary--c9749";